// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"taa-z","narrowOptionButtons":"uaa-z","noOptions":"vaa-z"};